/**
 * @file Handling site info
 *
 *
 * @author Anders Halvorsen
 * @version 1.0.0
 *
 *
 */

import stringHelper from '@/Scripts/lib/helper/stringHelper.js';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      links: state => state.siteInfo.links,
      notificationSettings: state => state.siteInfo.notification,
      countries: state => state.siteInfo.countries,
      usp: state => state.siteInfo.usp
    })
  },
  methods: {
    getLink (key) {
      if (Object.keys(this.links).length > 0) {
        return this.links[stringHelper.capitalize(key)];
      }
    },
    $_pageLinks_login: function () {
      if (Object.entries(this.links).length === 0) {
        setTimeout(() => {
          this.$_pageLinks_login();
        }, 50);
      } else {
        window.location.href = `${window.location.origin}${this.getLink('loginPage')}?ReturnUrl=${location.pathname}${location.search}`;
      }
    }
  },
  mounted () {
    this.$store.dispatch('siteInfo/getSiteInformation');
  }
};
